import React, { useContext } from 'react';
import Faq from './Faq';
import ConfigContext from '../../../contexts/ConfigContext';

const getBbqFaqQuestions = (cityName, siteTitle, vehicleType) => [
  {
    question: `How much does barbecue food ${vehicleType} catering cost in ${cityName}?`,
    answer: `Barbecue food ${vehicleType} catering costs in ${cityName} depend on the number of guests, menu selections, and service length. Smaller private events may start at a few hundred dollars, while larger corporate events, weddings, and festivals typically scale higher. ${siteTitle} allows you to compare real quotes from barbecue food ${vehicleType}s so you can find high-quality catering that fits your budget, with clear pricing and no hidden fees.`
  },
  {
    question: `What types of barbecue can a food ${vehicleType} serve at my event?`,
    answer: `Barbecue food ${vehicleType}s offer a wide range of options, from Texas-style slow-smoked meats and Carolina pulled pork to Kansas City burnt ends. Many vendors also offer house-made sauces and a variety of sides, making it easy to tailor the menu to your event.`
  },
  {
    question: `Are barbecue food ${vehicleType}s a good choice for corporate events and large groups?`,
    answer: `Yes. Barbecue food ${vehicleType}s are a popular catering option for corporate lunches, employee appreciation events, and large gatherings. Barbecue is fast to serve, familiar, and crowd-pleasing, making it ideal for events with diverse tastes and tight schedules. ${siteTitle} works with experienced barbecue ${vehicleType}s that regularly serve corporate campuses and high-volume events.`
  },
  {
    question: `Can barbecue food ${vehicleType}s accommodate vegetarian, vegan, or gluten-free diets?`,
    answer: `Most barbecue food ${vehicleType}s offer vegetarian and plant-based options, and many can provide gluten-free sides or alternatives. When submitting your catering request, you can note any dietary preferences or allergies, and we'll match you with food ${vehicleType}s that can accommodate your guests' needs.`
  },
  {
    question: `How far in advance should I book a barbecue food ${vehicleType} for catering?`,
    answer: `For best availability, we recommend booking a food ${vehicleType} 3–6 weeks in advance, especially for summer events, weddings, and corporate catering. However, last-minute bookings may be possible depending on availability. Submitting your request early gives you more menu options and scheduling flexibility.`
  }
];

function BbqFaq() {
  const { city_name, site_title, vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const questions = getBbqFaqQuestions(city_name, site_title, vehicleType);

  return (
    <Faq questions={questions} />
  );
}

export default BbqFaq;
